import React, {useEffect, useState} from 'react';
import MaterialStripeTable
    from "../../../../../components/UI/table/warehouse/material/materialStripe/MaterialStripeTable";
import {useParams} from "react-router-dom";
import UserSupplierMaterialService from "../../../../../API/orders/warehouse/material/UserSupplierMaterialService";
import AdminSupplierMaterialCloudService from "../../../../../API/admin/AdminSupplierMaterial";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {constantsErrorMessages} from "../../../../../Constants";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";

const MaterialFixedStripeArchiveItem = () => {

    const [data, setData] = useState([]);

    const params = useParams();

    const materialId = params.materialId

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [alertData, setAlertData] = useState({});

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState, currTab) => {
        setTableOptions(nextState)
    }
    useEffect(() => {
        AdminSupplierMaterialCloudService.getAllByMaterialIdFixedStripe(materialId)
            .then(function (response) {
                setData(response.data);
            })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Архив цен"}
                path={[{name: "Главная", href: "/"}, {name: "Материалы", href: "/all-materials"}]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Box sx={{display: "flex", flexDirection: "column", gap: "16px"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Архив цен
                    </Typography>
                </Box>
            </Box>
            <MaterialStripeTable
                data={data}
                setData={setData}
                materialId={materialId}
                baseUnit={params.baseUnit}
                typeMaterial={params.typeMaterial}
                isArchive={true}
                isAll={true}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </Box>
    );
};

export default MaterialFixedStripeArchiveItem;